
export type Article = {
  titre: string
  media: string
  url: string
  date: string
  type: string
  citation: string
  logo_url: string
}

export const PRESS_ARTICLES: Article[] = [
  {
    'titre': 'Il achète une maison à 370.000 euros à Lyon avec ses cryptomonnaies, une première en France',
    'media': 'BFMTV (BFM Crypto)',
    'url': 'https://www.bfmtv.com/crypto/il-achete-une-maison-a-370-000-euros-a-lyon-avec-ses-cryptomonnaies-une-premiere-en-france_AN-202506180502.html',
    'date': '2025-06-18',
    'type': 'Article web',
    'citation': 'Un acquéreur a utilisé ses cryptomonnaies pour acheter sa résidence principale, le vendeur a reçu des euros. Un détenteur de cryptomonnaies a acheté, avec ses stablecoins USDC, une maison à 370 000 euros dans la région de Lyon grâce à Legibloq de la startup française JBDA.',
    'logo_url': '/press/logo-bfmtv.png'
  },
  {
    'titre': 'Il achète une maison en cryptos, le vendeur reçoit des euros : une première en France',
    'media': 'Capital',
    'url': 'https://capital.fr/immobilier/il-achete-une-maison-en-cryptos-le-vendeur-recoit-des-euros-une-premiere-en-france-1514591',
    'date': '2025-06-04',
    'type': 'Article web',
    'citation': 'Acheter un bien immobilier en cryptomonnaie tout en payant le vendeur en euros ? C’est ce que prévoit une transaction inédite qui doit avoir lieu le 19 juin dans la région lyonnaise. Elle implique un salarié de 35 ans et sa famille, qui ont fait une offre de 370 000 euros pour devenir propriétaire de la maison de leur rêve.',
    'logo_url': '/press/capital-favicon.ico'
  },
  {
    'titre': 'Acheter une maison en cryptomonnaie mais payer le vendeur en euros ? C’est possible, voici comment',
    'media': 'Boursorama',
    'url': 'https://www.boursorama.com/patrimoine/actualites/acheter-une-maison-en-cryptomonnaie-mais-payer-le-vendeur-en-euros-c-est-possible-voici-comment-0001f3c9c384d139e6e0600eca2597a6',
    'date': '2025-06-05',
    'type': 'Article web',
    'citation': 'En France, il est désormais possible d’acheter une maison en cryptomonnaie tout en payant le vendeur en euros. Une première transaction de ce type doit avoir lieu le 19 juin prochain dans la région lyonnaise. Le bien, estimé à 370 000 euros, sera acquis grâce à des stablecoins convertis en monnaie traditionnelle par une startup.',
    'logo_url': '/press/logo-boursorama.png'
  },
  {
    'titre': 'France : le tout premier achat immobilier crypto a été réalisé !',
    'media': 'BeInCrypto (FR)',
    'url': 'https://fr.beincrypto.com/marches/554982/france-enregistre-premier-achat-immobilier-crypto/',
    'date': '2025-06-05',
    'type': 'Article web',
    'citation': 'Le pays vient en effet d’enregistrer le premier achat immobilier financé entièrement en cryptomonnaies. Un salarié de 35 ans et sa famille deviennent propriétaires d’une résidence principale dans la région lyonnaise, financée entièrement en stablecoins.',
    'logo_url': '/press/bic-favicon.png.webp'
  },
  {
    'titre': 'Immobilier et crypto : une première transaction légale réussie en France avec Legibloq',
    'media': 'Club Patrimoine',
    'url': 'https://www.clubpatrimoine.com/contenus/immobilier-cryptomonnaie-premiere-transaction',
    'date': '2025-06-05',
    'type': 'Article web',
    'citation': 'JBDA, jeune startup basée à Sophia Antipolis, a réalisé en juin 2025 une première en France : une transaction immobilière financée exclusivement en cryptomonnaie, via sa solution Legibloq®. Cette innovation a permis l’achat d’une maison à Lyon pour 370 000 euros, sans conversion préalable des crypto-actifs.',
    'logo_url': 'https://media.licdn.com/dms/image/v2/C4E03AQFGVn-_Zfa0Ow/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1653309834635?e=2147483647&v=beta&t=l4aicemdgIE1Lk6DMETE0W8Hg3xEBeWzoCx0c3RtAac'
  },
  {
    'titre': 'Sophia : JBDA annonce la première transaction immobilière en cryptomonnaie',
    'media': 'SophiaNet',
    'url': 'https://www.sophianet.com/article/sophia-jbda-annonce-premiere-transaction-immobiliere-cryptomonnaie',
    'date': '2025-06-04',
    'type': 'Article web',
    'citation': 'Une première en France : une transaction immobilière inédite en cryptomonnaie... Cette première opération concerne l’achat en ce mois de juin d’une maison en résidence principale dans la région de Lyon pour un montant de 370 000 euros.',
    'logo_url': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTE-tgY_VBhxSxv4dQcZj7Br2B7BPF1Hz7tWA&s'
  },
  {
    'titre': 'Acheter une maison avec des bitcoins ? C’est (déjà) légal',
    'media': 'Ideal-investisseur.fr',
    'url': 'https://www.ideal-investisseur.fr/briefing-du-jour/2025-06-05.html',
    'date': '2025-06-05',
    'type': 'Article web',
    'citation': 'À Lyon, une maison a été achetée entièrement en cryptomonnaie (370 000 €), grâce à la solution Legibloq®. L’acheteur a payé en crypto, le notaire a versé les euros au vendeur. Le tout 100 % conforme.',
    'logo_url': 'https://logo.clearbit.com/ideal-investisseur.fr?size=256'
  },
  {
    'titre': 'Bien immobilier : une première transaction avec des cryptomonnaies a été réalisée en France',
    'media': 'Zoom Invest',
    'url': 'https://zoominvest.fr/articles/view/05-06-25/bien-immobilier-une-premiere-transaction-avec-des-cryptomonnaies-a-ete-realisee-en-france/',
    'date': '2025-06-05',
    'type': 'Article web',
    'citation': 'Grâce au savoir-faire de la start-up JBDA, une première transaction immobilière par l’intermédiaire de cryptomonnaie a été réalisée en France. L’achat sera finalisé chez un notaire partenaire le 19 juin. Un acheteur a financé sa maison en cryptomonnaies tout en assurant au vendeur un paiement en euros.',
    'logo_url': '/press/zoominvest-favicon.ico'
  },
  {
    'titre': 'France : le tout premier achat immobilier crypto a été réalisé !',
    'media': 'Bitget News',
    'url': 'https://www.bitget.com/fr/news/detail/12560604797452',
    'date': '2025-06-05',
    'type': 'Article web',
    'citation': 'La première transaction immobilière crypto a été réalisée par Legibloq, une plateforme française innovante qui propose un service de séquestre crypto-asset certifié.',
    'logo_url': 'https://logo.clearbit.com/bitget.com?size=256'
  },
  {
    'titre': 'Une première en France : une transaction immobilière avec cryptomonnaies, le vendeur perçoit des euros',
    'media': 'World in Maps',
    'url': 'https://worldinmaps.fr/une-premiere-en-france-une-transaction-immobiliere-en-cryptomonnaies-le-vendeur-percoit-des-euros/',
    'date': '2025-06-06',
    'type': 'Article web',
    'citation': 'Dans un tournant inédit pour l’immobilier français, l’acquisition d’une maison dans la région lyonnaise sera officiellement enregistrée le 19 juin : l’achat sera effectué en cryptomonnaies, tandis que le vendeur recevra intégralement la somme en euros. Cette opération est rendue possible grâce à la start-up JBDA et sa solution Legibloq.',
    'logo_url': '/press/logo-worldinmaps.png'
  },
  {
    'titre': 'Achat immobilier en cryptomonnaie : une première en France où le vendeur encaisse en euros',
    'media': 'oboncoin.fr',
    'url': 'https://www.oboncoin.fr/achat-immobilier-cryptomonnaie/',
    'date': '2025-06-12',
    'type': 'Article web',
    'citation': 'L’initiative mise en place par JBDA via sa solution Legibloq représente un tournant pour le secteur immobilier français. Grâce à cette technologie, une famille a réalisé un achat en cryptomonnaie, une première en France. L’événement du 19 juin a vu un salarié de 35 ans acquérir une maison en région lyonnaise pour 370 000 euros.',
    'logo_url': '/press/logo-oboncoin.png'
  },
  {
    'titre': 'Une première en France réalisée en cryptomonnaie grâce à Legibloq (Post LinkedIn)',
    'media': 'LinkedIn – Thomas Putine',
    'url': 'https://www.linkedin.com/feed/update/urn:li:activity:xxxxxxxxxx',
    'date': '2025-06-04',
    'type': 'Publication sur LinkedIn',
    'citation': '« J’ai eu l’honneur et le plaisir de réaliser la toute première vente immobilière en cryptomonnaie en France (acheteur en stablecoins, vendeur en euros) grâce à la solution Legibloq® développée par JBDA… »',
    'logo_url': '/press/logo-linkedin.png'
  }
  // {
  //   'titre': 'Une première en France réalisée en cryptomonnaie grâce à Legibloq (Tweet)',
  //   'media': 'X – @Legibloq (JBDA)',
  //   'url': 'https://x.com/Legibloq/status/1934561079973048797',
  //   'date': '2025-06-04',
  //   'type': 'Publication sur X',
  //   'citation': '« Une première en France : une transaction immobilière inédite réalisée en cryptomonnaie grâce à @Legibloq ! »',
  //   'logo_url': '/press/logo-x.jpg'
  // }
]

